// extracted by mini-css-extract-plugin
export default {"box":"formTextArea_box__HpWK2","box__input":"formTextArea_box__input__D+f4y","box__label":"formTextArea_box__label__RCu06"};